export const LOCAL_BASE_URL = 'http://localhost:4200/';

export const USE_LOCAL_TWAICE_API = false;
